const EVENT_SPEC_STYLE_MAP = {
  "": {
    display_name: "No Result",
    color: "var(--color-text-specs-blue)", // light blue
    rgb_values: "38, 171, 225",
    box_shadow_color: "rgba(38, 171, 225, 0.21)",
    border_color: "var(--color-cool-specs)",

    text_color: "var(--color-text-specs-blue)",
    sample_border_color: "var(--color-border-specs)",
    sample_bg_color: "var(--color-content-inverse)",
  },
  0: {
    display_name: "In Process",
    color: "var(--color-content-warning)", // orange
    rgb_values: "225, 178, 38",
    box_shadow_color: "rgba(225, 178, 38, 0.2)",
    border_color: "var(--color-content-warning)",

    text_color: "var(--color-content-warning-text)",
    sample_border_color: "var(--color-content-warning-text)",
    sample_bg_color: "var(--color-content-warning-bg)",
  },
  1: {
    display_name: "In Spec",
    color: "var(--color-content-positive)", // green
    rgb_values: "30, 192, 74",
    box_shadow_color: "rgba(30, 192, 74, 0.3)",
    border_color: "var(--color-content-positive)",

    text_color: "var(--color-content-positive)",
    sample_border_color: "var(--color-content-positive)",
    sample_bg_color: "var(--color-content-positive-bg)",
  },
  2: {
    display_name: "Out of Spec",
    color: "var(--color-content-negative)", // red
    rgb_values: "225, 25, 3",
    box_shadow_color: "rgba(225, 25, 3, 0.3)",
    border_color: "var(--color-content-negative)",

    text_color: "var(--color-content-negative)",
    sample_border_color: "var(--color-content-negative)",
    sample_bg_color: "var(--color-content-negative-bg)",
  },
  3: {
    display_name: "Spec Incomplete",
    color: "var(--color-border-specs-dark)", // gray
    rgb_values: "80, 80, 80",
    box_shadow_color: "rgba(0, 0, 0, 0.15)",
    border_color: "var(--color-border-specs-light)",

    text_color: "var(--color-border-specs-dark)",
    sample_border_color: "var(--color-border-specs)",
    sample_bg_color: "var(--color-border-specs-tertiary)",
  },
  4: {
    display_name: "In Process - Retest", // retest
    color: "var(--color-content-warning)", // orange
    rgb_values: "225, 178, 38",
    box_shadow_color: "rgba(225, 178, 38, 0.2)",
    border_color: "var(--color-content-warning)",

    text_color: "var(--color-content-warning-text)",
    sample_border_color: "var(--color-content-warning-text)",
    sample_bg_color: "var(--color-content-warning-bg)",
  },
  5: {
    display_name: "In Spec - Retest", // retest
    color: "var(--color-content-positive)", // green
    rgb_values: "30, 192, 74",
    box_shadow_color: "rgba(30, 192, 74, 0.3)",
    border_color: "var(--color-content-positive)",

    text_color: "var(--color-content-positive)",
    sample_border_color: "var(--color-content-positive)",
    sample_bg_color: "var(--color-content-positive-bg)",
  },
  6: {
    display_name: "Out of Spec - Retest", // retest
    color: "var(--color-content-negative)", // red
    rgb_values: "225, 25, 3",
    box_shadow_color: "rgba(225, 25, 3, 0.3)",
    border_color: "var(--color-content-negative)",

    text_color: "var(--color-content-negative)",
    sample_border_color: "var(--color-content-negative)",
    sample_bg_color: "var(--color-content-negative-bg)",
  },
  "-1": {
    display_name: "Sampled",
    color: "var(--color-cool-primary)",
    rgb_values: "255, 159, 63",
    box_shadow_color: "rgba(255, 159, 63, 0.3)",
    border_color: "var(--color-cool-primary)",

    text_color: "var(--color-text-specs-orange)",
    sample_border_color: "var(--color-text-specs-orange)",
    sample_bg_color: "var(--color-text-specs-orange-light)",
  },
  "-2": {
    display_name: "Scheduled",
    color: "var(--color-border-focus)", // grey
    rgb_values: "196, 210, 223",
    box_shadow_color: "rgba(196, 210, 223, 0.3)",
    border_color: "var(--color-border-focus)",

    text_color: "var(--color-content-base)",
    sample_border_color: "var(--color-content-base)",
    sample_bg_color: "var(--color-bg-secondary-soft)",
  },
  "-3": {
    display_name: "Deleted by Lab",
    color: "var(--color-content-negative)", // red
    rgb_values: "225, 25, 3",
    box_shadow_color: "rgba(225, 25, 3, 0.3)",
    border_color: "var(--color-content-negative)",

    text_color: "var(--color-content-negative)",
    sample_border_color: "var(--color-content-negative)",
    sample_bg_color: "var(--color-content-negative-bg)",
  },
  "-4": {
    display_name: "Setup Required",
    color: "var(--color-content-warning-text)",
    rgb_values: "193, 138, 0",
    box_shadow_color: "rgba(193, 138, 0, 0.3)",
    border_color: "var(--color-content-warning-text)",

    text_color: "var(--color-content-warning-text)",
    sample_border_color: "var(--color-content-warning-text)",
    sample_bg_color: "var(--color-content-warning-bg)",
  },
  "-5": {
    display_name: "Deleted by User",
    color: "var(--color-content-negative)", // red
    rgb_values: "225, 25, 3",
    box_shadow_color: "rgba(225, 25, 3, 0.3)",
    border_color: "var(--color-content-negative)",

    text_color: "var(--color-content-negative)",
    sample_border_color: "var(--color-content-negative)",
    sample_bg_color: "var(--color-content-negative-bg)",
  },
};

export default EVENT_SPEC_STYLE_MAP;
